export const manyUserXlsxColumns = {
  senha_do_usuario: "",
  cpf_do_usuario: "",
  email_do_usuario: "",
  nome_do_usuario: "",
  rg_do_usuario: "",
  cargo_do_usuario: "",
  tem_agenda_definida: "",
  horario_entrada_segunda_feira: "",
  horario_saida_segunda_feira: "",
  horario_entrada_terca_feira: "",
  horario_saida_terca_feira: "",
  horario_entrada_quarta_feira: "",
  horario_saida_quarta_feira: "",
  horario_entrada_quinta_feira: "",
  horario_saida_quinta_feira: "",
  horario_entrada_sexta_feira: "",
  horario_saida_sexta_feira: "",
  horario_entrada_sabado: "",
  horario_saida_sabado: "",
  horario_entrada_domingo: "",
  horario_saida_domingo: "",
};

export const userRolesIds = {
  usuario: "27b34b06-b951-4a01-98b5-c01ae504f230" as const,
  atendente: "21aa3d03-a4c3-4cd3-aa6f-852cfe037ef0" as const,
  financeiro: "e192d5a2-7795-4f4b-aaeb-1b7a173f9f15" as const,
};

export type ManyUserColumnsTypes = keyof typeof manyUserXlsxColumns;
